import './App.css';
import React, { Component } from 'react'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Landing from "./components/landing";
import Youtube from "./components/tutorials/youtube"
import Facebook from "./components/tutorials/facebook"
import Whatsapp from "./components/tutorials/whatsapp"
import Telegram from "./components/tutorials/telegram"
import Instagran from "./components/tutorials/instagram"
import Twitter from "./components/tutorials/twitter"
import Hotstar from "./components/tutorials/hotstar"
export default class App extends Component {
  
  render() {
    return (
      <>
        <Router>
          <Routes>
            <Route exact path='/' element={<Landing />} />
            <Route exact path='/youtube' element={<Youtube />} />
            <Route exact path='/twitter' element={<Twitter />} />
            <Route exact path='/whatsapp' element={<Whatsapp />} />
            <Route exact path='/instagram' element={<Instagran />} />
            <Route exact path='/telegram' element={<Telegram />} />
            <Route exact path='/hotstar' element={<Hotstar />} />
            <Route exact path='/facebook' element={<Facebook />} />
            {/* <Route exact path='/login' element={<Login />} />
            {this.state.email &&
              <Route exact path="/dashboard" element={<Dashboard />} />
            }
            {this.state.email &&
              <Route exact path='/calender' element={<Calender />} />
            }
            {this.state.email &&
              <Route exact path='/chart' element={<Chart />} />
            } */}
          </Routes>
        </Router>
      </>

    );

  }

}

